<template>
  <b-button v-if="!$store.state.isLoggedIn && !$store.state.isLoginProcessing" class="has-text-weight-bold is-info"
    @click="signUp(redirect_uri)" rounded v-html="$t('signup_button')"></b-button>
</template>

<script>
export default {
  name: "ButtonSignUp",
  props: {
    redirect_uri: {
      type: String,
      default: '/dashboard'
    }
  }
}
</script>

<style lang="scss" scoped></style>
